const pad = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
const nextDay = (iso) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + 1); return d; };

export const googleCalendarUrl = ({ title, details, date, url }) => {
  const start = ymd(new Date(`${date}T12:00:00`));
  const params = new URLSearchParams({ action: "TEMPLATE", text: title, dates: `${start}/${ymd(nextDay(date))}`, details: `${details}\n${url}` });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

const esc = (s) => s.replace(/[\\,;]/g, (m) => `\\${m}`).replace(/\n/g, "\\n");

export const downloadIcs = ({ id, title, details, date, url }) => {
  const start = ymd(new Date(`${date}T12:00:00`));
  const stamp = new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//NC Legal Forms//Filing Due Date//EN", "BEGIN:VEVENT",
    `UID:${id}-${start}@formsnc.com`, `DTSTAMP:${stamp}`, `DTSTART;VALUE=DATE:${start}`, `DTEND;VALUE=DATE:${ymd(nextDay(date))}`,
    `SUMMARY:${esc(title)}`, `DESCRIPTION:${esc(`${details}\n${url}`)}`, `URL:${url}`,
    "BEGIN:VALARM", "TRIGGER:-P3D", "ACTION:DISPLAY", `DESCRIPTION:${esc(title)}`, "END:VALARM",
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${title.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.ics`;
  a.click();
  URL.revokeObjectURL(a.href);
};
